<div>
    <img class="w-100" src="assets/images/contact-us.png" alt="contactez-nous">
</div>